import 'reflect-metadata';

export class DecoratorUtil {
	/**
	 * The method currents the string value to the type the decorator is in
	 */
	public static convertValueToType(target: any, propertyKey: string, propertyValue: any, options?: { separator?: string }): any {
		if (typeof propertyValue !== 'string') {
			return propertyValue;
		}

		const propertyType = Reflect.getMetadata('design:type', target, propertyKey);
		const propertyTypeName: string = propertyType?.name?.toLowerCase() ?? '';

		if (propertyTypeName === 'number') {
			return Number(propertyValue);
		} else if (propertyTypeName === 'boolean') {
			return propertyValue === 'true';
		} else if (propertyTypeName === 'array') {
			let toArray = propertyValue.split(options?.separator ?? ',')
				.map(entry => entry.replace('%2C', ','));

			if (toArray[0] === 'list') {
				toArray = toArray.splice(1);
			}

			return toArray;
		} else if (propertyTypeName !== 'string' && (propertyValue.startsWith('{') || propertyValue.startsWith('['))) {
			// If its json
			try {
				const result = JSON.parse(propertyValue);
				const type = Object.prototype.toString.call(result);
				if (type === '[object Object]' || type === '[object Array]') {
					return result;
				}
			} catch (err) { }
		}

		return propertyValue;

	}
}
